"use strict";
/**
 * OverlayState is a bag of values for either the initial configuration or current state of an
 * overlay.
 */
var OverlayState = (function () {
    function OverlayState() {
    }
    return OverlayState;
}());
exports.OverlayState = OverlayState;
//# sourceMappingURL=overlay-state.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular2-material/core/overlay/overlay-state.js
 ** module id = 906
 ** module chunks = 2
 **/